export const testIdName = 'more-vs-apps';
